import MoreInfoView from 'text!./views/more-info.html';
import PolicySelectGatewayCtrl from './controllers/PolicySelectGatewayCtrl';
import PolicySelectGatewayView from 'text!./views/policy-select.html';
import PolicyService from './services/PolicyService';
import _ from 'lodash';
import 'edge/fnol/app';

export default angular.module('edge.gateway.fnol.common.app', ['edge.fnol.app'])

    .config(['$provide', ($provide) => {
        $provide.decorator('fnol.LoadSaveService', ['$delegate', 'JsonRPCService', ($delegate, JsonRPCService) => {
            const origGetClaim = $delegate.getClaim;
            $delegate.getClaim = (callGroups, claimNumber) => {
                return origGetClaim(callGroups, claimNumber).then(claim => {
                    // Error handling? Who cares, user already sees the data.
                    JsonRPCService.send('cc', 'gatewayclaim/claim', 'addRecentlyViewedClaim', [claim.claimNumber]);
                    return claim;
                });
            };
            return $delegate;
        }]);
    }])

    .factory('fnol.PolicyService', PolicyService)

    .value('fnol.endpointConfig', {
        'loadSaveEndpoint': 'gatewayfnol/fnol'
    })

    // override base FNOL configuration for gateway portal
    .run(['$state', ($state) => {
        const moreInfoState = $state.get('moreInfo');
        moreInfoState.template = MoreInfoView;
        // PSA: always allow to search & select ANY policy (just like VendorEngage-producer persona)
        /* const policySelect = $state.get('policySelect');
        const gatewayPolicySelect = _.cloneDeep(policySelect);
        gatewayPolicySelect.controller = PolicySelectGatewayCtrl;
        gatewayPolicySelect.template = PolicySelectGatewayView;
        $state.router.stateRegistry.deregister('policySelect');
        $state.router.stateRegistry.register(gatewayPolicySelect); */
    }]);